import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BiLogInCircle } from 'react-icons/bi';

const TopNavbar = () => {
  const history = useNavigate();

  const logOutUser = () => {
    localStorage.removeItem('centralize-dev-user-token');
    localStorage.removeItem('centralize-super-admin');
    localStorage.removeItem('centralize-admin-token');
    history('/');
  };

  return (
    <nav
      className="navbar"
      style={{
        backgroundColor: '#1D1D1D',
        height: '50px',
      }}
    >
      <div className="container-fluid">
        <div> </div>

        <div onClick={logOutUser} className="text-white text-center">
          <BiLogInCircle size="1.8rem" />
        </div>
      </div>
    </nav>
  );
};

export default TopNavbar;
